// import ComponentsPage from "views/ComponentsPage/ComponentsPage.jsx";
// import LandingPage from "views/LandingPage/LandingPage.jsx";
// import ProfilePage from "views/ProfilePage/ProfilePage.jsx";

import LoginPage from "views/LoginPage/LoginPage.jsx";
import NewsArticlesPage from "views/NewsArticlesPage/NewsArticlesPage.jsx";
import RelatedArticlesPage from "views/NewsArticlesPage/RelatedArticlesPage.jsx";
import DetailsPage from "../views/DetailsPage/DetailsPage";


var indexRoutes = [
    // { path: "/landing-page", name: "LandingPage", component: LandingPage },
    // { path: "/profile-page", name: "ProfilePage", component: ProfilePage },
    // { path: "/component-page", name: "ComponentsPage", component: ComponentsPage },
    { path: "/login-page", name: "LoginPage", component: LoginPage },
    { path: "/", name: "ArticlePage", component: NewsArticlesPage },
    { path: "/related/:id", name: "RelatedArticlesPage", component: RelatedArticlesPage},
    { path: "/details/:id", name: "DetailsPage", component: DetailsPage}
];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx